 <div class="container" style="margin-top:-20px;">
  <ds-carusel></ds-carusel>

  <div class="d-flex flex-wrap bandera">
      <div>
        <p class="lead">El repositorio <b style="font-weight: bolder;">Biblioteca Digital Juan de Villanueva</b> nace con el propósito de preservar y difundir en formato digital el valioso patrimonio bibliográfico de la Biblioteca del COAM compuesto fundamentalmente por los manuscritos, monografías y publicaciones periódicas pertenecientes a su Fondo Antiguo y, además, servir como herramienta de apoyo a arquitectos, estudiantes e investigadores.</p>
      </div>
    </div>
    <p><a href="https://coam.org"
        target="_blank">Colegio Oficial de Arquitectos de Madrid</a>
    </p>
  </div>
